export default "__VITE_ASSET__1YAgZAuZ__"